export const WALLET_REQUEST = `
query walletRequest(
  $id: Int!,
  $tenant_id: Int!
){
  walletRequest(
    id:$id,
  	tenant_id:$tenant_id
  ){
    __typename
    ...on WalletRequest{
      id
      its
      tenant_id
      tenant{
      	name
        bank_account_holder
        bank_account_identification_type_id
        bank_account_identification
        bank_account_cbu
        bank_account_alias
    	}
      type
      amount
      status
      description
      decision_message
      decision_date
      decision_user_id
      decision_user{
        contact{
          firstname
          lastname
        }
        username
        email
      }
      createdBy{
        contact{
          firstname
          lastname
        }
        username
        email        
      }
      wallet_request_file{
        id
        url
        filename
      }
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const WALLET_REQUESTS = `
query walletRequests(
  $tenant_id: Int!
  $skip: Int,
  $take: Int,
  $orderBy: WalletRequestOrderInput,
  $filter: FilterWalletRequestInput,
  $searchText: String
){
  walletRequests(
    tenant_id:$tenant_id,
    skip:$skip,
    take:$take,
    orderBy:$orderBy,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on WalletRequest{
      id
      its
      tenant_id
      tenant{
      	name
        bank_account_holder
        bank_account_identification_type_id
        bank_account_identification
        bank_account_cbu
        bank_account_alias
    	}
      type
      amount
      status
      description
      decision_message
      decision_date
      decision_user_id
      decision_user{
        contact{
          firstname
          lastname
        }
        username
        email  
      }
      createdBy{
        contact{
          firstname
          lastname
        }
        username
        email        
      }
      wallet_request_file{
        id
        url
        filename
      }
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const WALLET_REQUEST_COUNT = `
query walletRequestCount(
  $tenant_id: Int!
  $orderBy: WalletRequestOrderInput,
  $filter: FilterWalletRequestInput,
  $searchText: String
){
  walletRequestCount(
    tenant_id:$tenant_id,
    orderBy:$orderBy,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on Count{
      count
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
